import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-downloading-modal',
  templateUrl: './downloading-modal.component.html',
  styleUrls: ['./downloading-modal.component.css']
})
export class DownloadingModalComponent {
  @ViewChild('classic') public templateRef: TemplateRef<any>;
  modalReference: NgbModalRef;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'sm'
  };

  constructor(private modalService: NgbModal) { }

  open() {
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
  }

  close() {
    this.modalReference.close();
  }
}
